import React from 'react'
import { isReactNativeApp } from '@mobi/web-native-comms/web'
import { createImageUrlFromHtml } from '../helpers/createImageUrlFromHtml'
import { convertImageUrlToBlob } from '../helpers/convertImageUrlToBlob'
import { resetTemporaryWidthOfPreviewElement, setTemporaryWidthOfPreviewElement } from '../helpers'

// TODO:
// * Optimise for better performance in web browser
// * Delay initial generation to allow SVG logo to load

/** Browser requires the image to be created prior to clicking share
 *  Otherwise browser will deny share due to time between action and share prompt
 */
export const useCreateImageForBrowser = ({
  shouldCreateImage,
  shouldHideCost,
  setIsBusy,
  previewImageElRef,
}: {
  shouldCreateImage: boolean
  shouldHideCost: boolean
  setIsBusy: React.Dispatch<React.SetStateAction<boolean>>
  previewImageElRef: React.RefObject<HTMLDivElement>
}): Blob | undefined => {
  const previewImageDataRef = React.useRef<Blob>()
  const [hasMounted, setHasMounted] = React.useState(false)

  React.useEffect(() => {
    setHasMounted(true)
  }, [])

  React.useEffect(() => {
    if (isReactNativeApp || !previewImageElRef.current || !shouldCreateImage || !hasMounted) {
      return
    }

    setIsBusy(true)
    const previewEl = previewImageElRef.current
    setTemporaryWidthOfPreviewElement(previewEl)

    setImageBlobOnRef(previewEl, previewImageDataRef).finally(() => {
      setIsBusy(false)
      resetTemporaryWidthOfPreviewElement(previewEl)
    })
  }, [shouldHideCost, shouldCreateImage, setIsBusy, previewImageElRef, hasMounted])

  return previewImageDataRef.current
}

// =============
// Local Helpers
// =============

async function setImageBlobOnRef(el: HTMLElement, ref: React.MutableRefObject<Blob | undefined>) {
  const imageUrl = await createImageUrlFromHtml(el)
  const blob = await convertImageUrlToBlob(imageUrl)
  ref.current = blob
}
